import { render, staticRenderFns } from "./garbage.vue?vue&type=template&id=38bc1a02&scoped=true&"
import script from "./garbage.vue?vue&type=script&lang=js&"
export * from "./garbage.vue?vue&type=script&lang=js&"
import style0 from "./garbage.vue?vue&type=style&index=0&id=38bc1a02&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38bc1a02",
  null
  
)

export default component.exports